import FooterItem from "./footerItem"

const FooterItems = () => {
    const menulists = [
        {
            title: "About Uniten",
            items: [
                {
                    name: "About UNITEN",
                    link: "/about"
                },
                {
                    name: "Colleges",
                    link: "/about?sideTab=8"
                },
                // {
                //     name: "Our Partners",
                //     link: "/our partners"
                // },
                {
                    name: "Our People",
                    link: "/our people"
                },
                {
                    name: "Our Alumni & Community",
                    link: "/our alumni"
                },
                {
                    name: "Contact Us",
                    link: "/contact us"
                },
            ]
        },
        {
            title: "education",
            items: [
                {
                    name: "Explore All Programs",
                    link: "/all-programmes"
                },
                // {
                //     name: " Foundation"
                // },

                // {
                //     name: "Diploma"
                // },
                // {
                //     name: "Undergraduate"
                // },
                // {
                //     name: "Postgraduate"
                // },
                {
                    name: "Scholarships",
                    link: "/scholarships"
                },
                {
                    name: "Admission",
                    link: "/admission"
                },
            ]
        },
        {
            title: "Explore",
            items: [
                {
                    name: "Staff",
                    link:"/staff hub"
                },
                {
                    name: "Student",
                    link:"/student hub"
                },
                {
                    name: "Campus Life",
                    link: "/campus Life"
                },
                {
                    name: "Academic Calendar",
                    link: "/academic calendar"
                },
                {
                    name: "News & Events",
                    link: "/news & events"
                },
                {
                    name: "Research",
                    link: "/research"
                },
                {
                    name: "TNB Official Website",
                    link:"https://www.tnb.com.my/"
                },

            ]
        },
        {
            title: "",
            items:
                [
                    {
                        name: "Training & Services",
                        link: "/training & services"
                    },
                    {
                        name: "Vacancies",
                        link: "/vacancies"
                    },
                    // {
                    //     name: "Course Generator",
                    //     link: "/course generator"
                    // },
                    {
                        name: "International Office",
                        link: "/international office"
                    },
                    {
                        name: "FAQ",
                        link: '/faq'
                    },
                ]
        }
    ]
    return (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 2xl:gap-4  w-full ">
            {
                menulists.map((item, index) => (
                    <FooterItem key={index} item={item} />
                ))
            }
        </div>
    )
}

export default FooterItems